import React, { useEffect, useState, useRef } from 'react';
import { useStateCallback } from '../../utils/stateCallback';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import InputLabel from '@material-ui/core/InputLabel';
import LoadingLayer from '../controls/LoadingLayer';
import FormControl from '@material-ui/core/FormControl';
import TextField from "@material-ui/core/TextField";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Popup } from "@progress/kendo-react-popup";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import AlertAlgo from '../controls/AlertSnack';
import * as StatusCode from '../../scripts/StatusCode';
import * as MaterialType from '../../scripts/MaterialResourceTypeMode';
import * as utils from '../../utils';
import { getMaterialResourceCode, getAllCombos, saveMaterial, tasksMaterial, sortTasksByCode } from '../../actions/materialResource';
import NumericTextField from '../controls/NumericTextField';
import { withNamespaces } from 'react-i18next';
import styles from '../../styles/materialResource.module.css';
import { loadLocalization } from '../../utils/kendoLocalization';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { GetLanguage, IsEnglish } from '../../utils/language';
import { GetABCUsage } from '../../utils/companyConfig';
import { paramDefault } from '../../actions/timesheet/paramDefault';
import { paramPayment } from '../../actions/timesheet/paramPayment';
import { sortActivityByCode } from '../../actions/timesheet/activity';
import { sortProjectByCode } from '../../actions/timesheet/project';
import * as storage from '../../utils/storage';
import moment from "moment";
import "moment/locale/fr";

loadLocalization();
moment.locale("fr");

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginBottom: '10px'
    }
}));

function MaterialResourceForm(props) {

    const [isProcessing, setIsProcessing] = useStateCallback(true);
    const [isPostCompleted, setIsPostCompleted] = useStateCallback(true);
    const [targetDate, setTargetDate] = useStateCallback(utils.convertToDate(new Date()));
    const [materialCodeUnit, setMaterialCodeUnit] = useStateCallback('');
    const [materialResourceId, setMaterialResourceId] = useStateCallback(0);
    const [materialResourceCodeId, setMaterialResourceCodeId] = useStateCallback(0);
    const [materialResourceCode, setMaterialResourceCode] = useStateCallback(null);
    const [materialResourceCodeF, setMaterialResourceCodeF] = useStateCallback(null);
    const [materialResourceCodeE, setMaterialResourceCodeE] = useStateCallback(null);
    const [quantity, setQuantity] = useStateCallback('');
    const [unit, setUnit] = useStateCallback('');
    const [displayUnit, setDisplayUnit] = useStateCallback('');
    const [project, setProject] = useStateCallback(null);
    const [activity, setActivity] = useStateCallback(null);
    const [projectPay, setProjectPay] = useStateCallback(null);
    const [activityPay, setActivityPay] = useStateCallback(null);
    const [taskPay, setTaskPay] = useStateCallback(null);

    const [projectDefault, setProjectDefault] = useStateCallback(null);
    const [activityDefault, setActivityDefault] = useStateCallback(null);
    const [projectPDefault, setProjectPDefault] = useStateCallback(null);
    const [activityPDefault, setActivityPDefault] = useStateCallback(null);
    const [taskDefault, setTaskDefault] = useStateCallback(null);

    const [originalProjectDefault, setOriginalProjectDefault] = useStateCallback(null);
    const [originalActivityDefault, setOriginalActivityDefault] = useStateCallback(null);
    const [originalProjectPDefault, setOriginalProjectPDefault] = useStateCallback(null);
    const [originalActivityPDefault, setOriginalActivityPDefault] = useStateCallback(null);
    const [originalTaskDefault, setOriginalTaskDefault] = useStateCallback(null);

    const [abcUsage, setABCUsage] = useStateCallback(null);
    const [linkProjectPActivity, setLinkProjectPActivity] = useStateCallback(null);
    const [companyPayProject, setCompanyPayProject] = useStateCallback(null);
    const [companyPayActivity, setCompanyPayActivity] = useStateCallback(null);
    const [companyPayTask, setCompanyPayTask] = useStateCallback(null);
    const [isCodeExists, setIsCodeExists] = useStateCallback(true);
    const [isDateChangedManually, setIsDateChangedManually] = useStateCallback(false);

    const [projects, setProjects] = useStateCallback([]);
    const [activitiesOriginal, setActivitiesOriginal] = useStateCallback([]);
    const [activities, setActivities] = useStateCallback([]);
    const [tasksPay, setTasksPay] = useStateCallback([]);
    const [listMaterialCode, setListMaterialCode] = useStateCallback(null);

    const [typeMode, setTypeMode] = useStateCallback(null);
    const [timesheetData, setTimesheetData] = useStateCallback(null);
    const [language, setLanguage] = useStateCallback('fr');
    const [locale, setLocale] = useStateCallback('fr');
    const alertRef = useRef(null);
    let _el;

    const classes = useStyles();


    useEffect(() => {
        const language = GetLanguage();

        moment.locale(language);
        setLocale(language);
        setLanguage(language);
    }, [])

    useEffect(() => {
        if (props.typeMode != null && props.typeMode === MaterialType.Type_Material) {
            setTypeMode(props.typeMode, (x) => {
                loadPage(x);
            });
        } else if (props.typeMode != null && props.typeMode === MaterialType.Type_Timesheet && props.timesheetData != null) {
            setTypeMode(props.typeMode);
            setTimesheetData(props.timesheetData, (x) => {
                loadPage(props.typeMode, x);
            });
        }
    }, [props.typeMode, props.timesheetData])

    useEffect(() => {
        if (abcUsage != null && companyPayProject != null && (projectDefault != null || projectPDefault != null)) {
            listCombos();

            setIsProcessing(false);
        } else {
            setIsProcessing(false);
        }
    }, [abcUsage, companyPayProject, projectDefault, projectPDefault])

    useEffect(() => {
        if (companyPayActivity != null &&
            (project != null && project.length > 0 && activitiesOriginal.length > 0)
            || (projectDefault != null && projectDefault.length > 0 && activitiesOriginal.length > 0)
            || (projectPay != null && projectPay.length > 0 && activitiesOriginal.length > 0)
            || (projectPDefault != null && projectPDefault.length > 0 && activitiesOriginal.length > 0)) {
            loadActivities();
        }
    }, [project, projectDefault, projectPay, projectPDefault, companyPayActivity, activitiesOriginal])

    useEffect(() => {
        if (props.data != null) {
            loadMaterial();
        }
    }, [props.data])

    useEffect(() => {
        listMaterialResourceCode(targetDate);
    }, [targetDate])

    useEffect(() => {
        let isExists = false;
        if (listMaterialCode != null && listMaterialCode.length > 0 && materialResourceId > 0 && materialResourceCode != null && materialResourceCode.length > 0) {
            isExists = listMaterialCode.find(x => x.resourceCode == materialResourceCode) != null;
        } else {
            isExists = true;
        }
        setIsCodeExists(isExists);
        if (isDateChangedManually) {
            isExists = listMaterialCode.find(x => x.materialResourceCodeId == materialResourceCodeId) != null;
            if (!isExists) {
                setMaterialCodeUnit(null);
                setMaterialResourceCodeId(0);
                setMaterialResourceCode(null);
                setMaterialResourceCodeF(null);
                setMaterialResourceCodeE(null);
                setUnit(null);
                setDisplayUnit(null);
            }
        }
    }, [listMaterialCode, materialResourceId, materialResourceCode, isDateChangedManually])

    useEffect(() => {
        if (unit != null && unit.length > 0 && listMaterialCode != null && listMaterialCode.length > 0) {
            const payUnit = listMaterialCode.filter(x => x.payUnit == unit)[0];
            if (payUnit != null) {
                setDisplayUnit(`${unit} - ${IsEnglish() ? payUnit.payUnitDescriptionE : payUnit.payUnitDescriptionF}`);
            }
        }
    }, [unit, listMaterialCode])


    const loadPage = async (typeMode, timesheetData) => {
        const param = await loadParamPay();
        await loadParamDefault(typeMode, timesheetData, param.projectPay, param.activityPay, param.taskPay);
    }

    const loadMaterial = () => {
        setTargetDate(new Date(props.data.Date));
        setMaterialCodeUnit(`${props.data.MaterialResourceCodeId}|${props.data.PayUnit}`);
        setMaterialResourceId(props.data.MaterialResourceId);
        setMaterialResourceCodeId(props.data.MaterialResourceCodeId);
        setMaterialResourceCode(props.data.ResourceCode);
        setMaterialResourceCodeF(props.data.MaterialResourceCodeF);
        setMaterialResourceCodeE(props.data.MaterialResourceCodeE);
        setQuantity(props.data.Quantity);
        setUnit(props.data.PayUnit);
        setProject(props.data.ABCProjectCode ?? '');
        setActivity(props.data.ABCActivityCode ?? '');
        setProjectPay(props.data.ProjectCode);
        setActivityPay(props.data.ActivityCode);
        setTaskPay(props.data.TaskCode);
    }

    const loadParamDefault = (typeMode, timesheetData, companyPayProject, companyPayActivity, companyPayTask) => {
        return new Promise((resolve) => {
            paramDefault().then((result) => {
                const param = JSON.parse(result.param);

                const _abcUsage = GetABCUsage();

                setABCUsage(_abcUsage);
                setLinkProjectPActivity(storage.getLinkProjectPActivity());

                if (typeMode === MaterialType.Type_Material) {
                    setProjectDefault(param.projectDef);
                    setProjectPDefault(param.projectPDef);
                    setActivityDefault(param.activityDef);
                    setActivityPDefault(param.activityPDef);
                    setTaskDefault(param.taskDef);
                } else {
                    setTargetDate(utils.convertToDate(timesheetData.targetDate));
                    setOriginalProjectDefault(param.projectDef);
                    setOriginalProjectPDefault(param.projectPDef);
                    setOriginalActivityDefault(param.activityDef);
                    setOriginalActivityPDefault(param.activityPDef);
                    setOriginalTaskDefault(param.taskDef);

                    if (companyPayProject) {
                        setProjectPDefault(timesheetData.project);
                    }

                    if (companyPayActivity) {
                        setActivityPDefault(timesheetData.activity);
                    }

                    if (companyPayTask) {
                        setTaskDefault(timesheetData.task);
                    }

                    if (_abcUsage) {
                        setProjectDefault(timesheetData.project);
                        setActivityDefault(timesheetData.activity);
                    }
                }
                resolve();
            });
        });
    }

    const loadParamPay = () => {
        return new Promise((resolve) => {
            paramPayment().then((result) => {
                const param = JSON.parse(result.param);

                setCompanyPayProject(param.projectPay)
                setCompanyPayActivity(param.activityPay)
                setCompanyPayTask(param.taskPay)
                resolve({ projectPay: param.projectPay, activityPay: param.activityPay, taskPay: param.taskPay });
            });
        });
    }

    const listCombos = async () => {
        await listCombosProjects();
        listMaterialResourceCode(targetDate);
    }

    const listCombosProjects = async () => {
        var result = await getAllCombos();

        if (result.status === StatusCode.STATUS_OK) {
            if (abcUsage == true) {
                setProjects(sortProjectByCode(result.projects));
            }

            if (companyPayProject == true) {
                setProjects(sortProjectByCode(result.projectsP));
            }

            let defaultProject = companyPayProject ? projectPay : project;

            if (defaultProject === null || defaultProject === '') {
                defaultProject = companyPayProject ? projectPDefault : projectDefault;
            }

            let list = companyPayProject ? result.projectsP : result.projects;

            // This is to avoid setting a project value in the save if no match project is found on the list
            let isMatch = list.filter(item => item.project === defaultProject);

            if (isMatch.length <= 0) {
                // Maybe the user was in ABC mode and than modified to pay mode, so the project saved is not on the right mode,
                // in this case, we will try the original default project. Because on the timesheet mode, the default project is the one that was saved
                defaultProject = companyPayProject ? originalProjectPDefault : originalProjectDefault;

                isMatch = list.filter(item => item.project === defaultProject);

                if (isMatch.length <= 0) {
                    defaultProject = '';
                }
            }

            setProject(companyPayProject ? '' : defaultProject);
            setProjectPay(companyPayProject ? defaultProject : '');
            setActivitiesOriginal(result.activities);
        } else {
            // Error
            const message = i18next.t('error:generic-error')
            showMessageError(message);
        }
    }

    const listMaterialResourceCode = async (date) => {
        var result = await getMaterialResourceCode(utils.formatDate(date, 'date'));

        if (result.status === StatusCode.STATUS_OK) {
            setListMaterialCode(result.data);
        }
    }

    const loadActivities = () => {
        return new Promise((resolve) => {
            if (!abcUsage && !companyPayActivity) {
                setActivity('');
                setActivityPay('');
                resolve();
                return;
            }

            const projectFilter = companyPayProject ?
                (utils.isEmpty(projectPay) ? projectPDefault : projectPay)
                : (utils.isEmpty(project) ? projectDefault : project);

            let list = activitiesOriginal;
            if (abcUsage || (companyPayProject && linkProjectPActivity)) {
                list = list?.filter(item => item.project == projectFilter);
            }

            let defaultActivity = companyPayActivity ? activityPay : activity;

            // This is to avoid setting an activity value in the save if no match activity is found on the list
            const isMatch = list?.filter(item => item.activity == defaultActivity);

            if (isMatch?.length <= 0) {
                defaultActivity = companyPayActivity ? activityPDefault : activityDefault;

                let isMatch = list?.filter(item => item.activity == defaultActivity);
                if (isMatch?.length <= 0) {
                    // Maybe the user was in ABC mode and than modified to pay mode, so the project saved is not on the right mode,
                    // in this case, we will try the original default activity. Because on the timesheet mode, the default activity is the one that was saved
                    defaultActivity = companyPayProject ? originalActivityPDefault : originalActivityDefault;

                    isMatch = list.filter(item => item.activity == defaultActivity);

                    if (isMatch.length <= 0) {
                        defaultActivity = '';
                    }
                }
            }

            setActivity(companyPayActivity ? '' : defaultActivity.toString());
            setActivityPay(companyPayActivity ? defaultActivity : '');
            loadTasks(defaultActivity);

            setActivities(sortActivityByCode(list));
            resolve();
        });
    }

    const loadTasks = (activity) => {
        return new Promise((resolve) => {
            setTasksPay([]);
            if (companyPayTask) {
                activity && tasksMaterial(activity).then((result) => {
                    if (result !== undefined) {
                        setTasksPay(sortTasksByCode(JSON.parse(result.tasks)))

                        let defaultTask = taskPay;

                        const list = JSON.parse(result.tasks);

                        // This is to avoid setting a project value in the save if no match project is found on the list
                        let isMatch = list.filter(item => item.taskCode === defaultTask);

                        if (isMatch.length <= 0) {
                            defaultTask = taskDefault;

                            isMatch = list?.filter(item => item.taskCode == defaultTask);
                            if (isMatch?.length <= 0) {
                                // Maybe the user was in ABC mode and than modified to pay mode, so the project saved is not on the right mode,
                                // in this case, we will try the original default task. Because on the timesheet mode, the default task is the one that was saved
                                defaultTask = originalTaskDefault;

                                isMatch = list.filter(item => item.taskCode === defaultTask);

                                if (isMatch.length <= 0) {
                                    defaultTask = '';
                                }
                            }
                        }

                        setTaskPay(defaultTask);
                    }
                    resolve();
                });
            }
            else {
                resolve();
            }
        });
    }

    const handleFocus = (event) => {
        // this should be good on desktop and android
        //event.target.select();

        // workaround to make it work in iOS
        event.target.setSelectionRange(0, event.target.value.length);
    }

    const onDateChange = (event) => {
        setTargetDate(event.target.value);
        setIsDateChangedManually(true);
    }

    const onChangeMaterialCodeUnit = (event) => {
        const materialValue = event.target.value;
        setMaterialCodeUnit(materialValue);

        const id = materialValue.split('|')[0];
        const unit = materialValue.split('|')[1];
        setMaterialResourceCodeId(id);
        setUnit(unit);
    }

    const onQuantityChange = (event) => {
        setQuantity(event.target.value);
    }

    const onChangeProject = (event) => {
        setProject(event.target.value);
    }

    const onChangeActivity = (event) => {
        setActivity(event.target.value);
    }

    const onChangeProjectPay = (event) => {
        setProjectPay(event.target.value);
    }

    const onChangeActivityPay = (event) => {
        setActivityPay(event.target.value);
        loadTasks(event.target.value);
    }

    const onChangeTask = (event) => {
        setTaskPay(event.target.value);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const handleSaveButtonClick = () => {
        setIsPostCompleted(false, () => {
            if (isValid()) {
                save();
            }
        });
    }

    const isValid = () => {
        let message = '';
        let isOK = true;

        if (targetDate === null) {
            message = i18next.t('materialResource:message.targetDate-form');
            isOK = false;
        } else if (!materialResourceCodeId > 0) {
            message = i18next.t('materialResource:message.materialCode-form');
            isOK = false;
        } else if (utils.isEmpty(unit)) {
            message = i18next.t('materialResource:message.unit-form');
            isOK = false;
        } else if (!quantity > 0) {
            message = i18next.t('materialResource:message.quantity-form');
            isOK = false;
        } else if ((abcUsage && utils.isEmpty(project))
            || (companyPayProject && utils.isEmpty(projectPay))) {
            message = i18next.t('materialResource:message.project-form');
            isOK = false;
        } else if ((abcUsage && utils.isEmpty(activity))
            || (companyPayActivity && utils.isEmpty(activityPay))) {
            message = i18next.t('materialResource:message.activity-form');
            isOK = false;
        } else if (companyPayTask && utils.isEmpty(taskPay)) {
            message = i18next.t('materialResource:message.task-form');
            isOK = false;
        } else if (typeMode === MaterialType.Type_Timesheet && timesheetData.timesheeId <= 0) {
            message = i18next.t('materialResource:message.timesheet-form');
            isOK = false;
        }

        if (!isOK) {
            showMessageError(message);
            setIsPostCompleted(true);
        }

        return isOK;
    }

    const save = async () => {
        const result = await saveMaterial(materialResourceId, materialResourceCodeId, utils.formatDate(targetDate, 'date'), utils.toDecimal(quantity), project, activity, projectPay, activityPay, taskPay, (timesheetData?.timesheetId ?? 0));

        if (result != null && result.status === StatusCode.STATUS_OK) {
            setIsPostCompleted(true);

            props.event({ saved: true, close: true, reload: true, type: typeMode, timesheetData: timesheetData });
        } else {
            // Error
            const message = i18next.t('error:generic-error')
            showMessageError(message);
            setIsPostCompleted(true);
        }
    }

    return (
        <LoadingLayer isActive={isProcessing}>
            <div id={"divMaterialForm"} className={styles.rootMaterialResourcePopBody}>
                <div ref={el => (_el = el)}>
                    <div className={classes.formControl}>
                        <LocalizationProvider language={locale}>
                            <IntlProvider locale={locale}>
                                <InputLabel className={"labelDatePicker required"} htmlFor="date">Date</InputLabel>
                                <DatePicker
                                    className={'required'}
                                    name="date"
                                    value={targetDate}
                                    onChange={onDateChange}
                                    format="yyyy-MM-dd"
                                    popup={props => <Popup {...props} appendTo={_el} />} />
                            </IntlProvider>
                        </LocalizationProvider>
                    </div>

                    <FormControl fullWidth className={classes.formControl}>
                        {isCodeExists && <InputLabel id="label-code" className={"required"}>{i18next.t('materialResource:form.materialResourceCode')}</InputLabel>}
                        {isCodeExists && <Select
                            labelId="label-code"
                            id="code"
                            value={materialCodeUnit || ''}
                            onChange={onChangeMaterialCodeUnit}
                            MenuProps={{ classes: { paper: styles.selectList } }}
                        >
                            {listMaterialCode && listMaterialCode.map((obj, index) =>
                                <MenuItem key={index} className={styles.selectItem} value={`${obj.materialResourceCodeId}|${obj.payUnit}`}>{`${obj.resourceCode} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                            )}
                        </Select>}
                        {!isCodeExists && <TextField
                            id="code"
                            label={i18next.t('materialResource:form.materialResourceCode')}
                            value={`${materialResourceCode} - ${IsEnglish() ? materialResourceCodeF : materialResourceCodeE}`}
                            className={"required"}
                            disabled={true}
                        />
                        }
                    </FormControl>

                    <FormControl fullWidth className={classes.formControl}>
                        <TextField
                            id="unit"
                            label={i18next.t('materialResource:form.unit')}
                            value={displayUnit || ''}
                            className={"required"}
                            disabled={true}
                        />
                    </FormControl>

                    <FormControl fullWidth className={classes.formControl}>
                        <NumericTextField
                            name="quantity"
                            label={i18next.t('materialResource:form.quantity')}
                            handleBlur={onQuantityChange}
                            value={quantity}
                            onFocus={handleFocus}
                            className={'required'}
                        />
                    </FormControl>

                    {abcUsage &&
                        (
                            <FormControl fullWidth className={classes.formControl}>
                                <InputLabel id="label-project" className={"required"}>{i18next.t('materialResource:form.project')}</InputLabel>
                                <Select
                                    className={styles.ddlTimesheetForm}
                                    labelId="label-project"
                                    id="project"
                                    value={project || projectDefault || ''}
                                    onChange={onChangeProject}
                                    MenuProps={{ classes: { paper: styles.selectList } }}
                                >
                                    {projects && projects.map((obj, index) =>
                                        <MenuItem key={index} className={styles.selectItem} value={obj.project}>{`${obj.project} - ${IsEnglish() ? obj.projectEn : obj.projectFr}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        )
                    }

                    {abcUsage &&
                        (
                            <FormControl fullWidth className={classes.formControl}>
                                <InputLabel id="label-activity" className={"required"}>{i18next.t('materialResource:form.activity')}</InputLabel>
                                <Select
                                    labelId="label-activity"
                                    id="activity"
                                    value={activity || activityDefault || ''}
                                    onChange={onChangeActivity}
                                    MenuProps={{ classes: { paper: styles.selectList } }}
                                >
                                    {activities && activities.map((obj, index) =>
                                        <MenuItem key={index} className={styles.selectItem} value={obj.activity}>{`${obj.activity} - ${IsEnglish() ? obj.activityEn : obj.activityFr}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        )
                    }

                    {companyPayProject &&
                        (
                            <FormControl fullWidth className={classes.formControl}>
                                <InputLabel id="label-project-pay" className={"required"}>{i18next.t('materialResource:form.project')}</InputLabel>
                                <Select
                                    labelId="label-project-pay"
                                    id="projectPay"
                                    value={projectPay || projectPDefault || ''}
                                    onChange={onChangeProjectPay}
                                    MenuProps={{ classes: { paper: styles.selectList } }}
                                >
                                    {projects && projects.map((obj, index) =>
                                        <MenuItem key={index} className={styles.selectItem} value={obj.project}>{`${obj.project} - ${IsEnglish() ? obj.projectEn : obj.projectFr}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        )
                    }

                    {companyPayActivity &&
                        (
                            <FormControl fullWidth className={classes.formControl}>
                                <InputLabel id="label-activity-pay" className={"required"}>{i18next.t('materialResource:form.activity')}</InputLabel>
                                <Select
                                    labelId="label-activity-pay"
                                    id="activityPay"
                                    value={activityPay || activityPDefault || ''}
                                    onChange={onChangeActivityPay}
                                    MenuProps={{ classes: { paper: styles.selectList } }}
                                >
                                    {activities && activities.map((obj, index) =>
                                        <MenuItem key={index} className={styles.selectItem} value={obj.activity}>{`${obj.activity} - ${IsEnglish() ? obj.activityEn : obj.activityFr}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        )
                    }

                    {companyPayTask &&
                        (
                            <FormControl fullWidth className={classes.formControl}>
                                <InputLabel id="label-task" className={"required"}>{i18next.t('materialResource:form.task')}</InputLabel>
                                <Select
                                    labelId="label-task"
                                    id="task"
                                    value={taskPay || taskDefault || ''}
                                    onChange={onChangeTask}
                                    MenuProps={{ classes: { paper: styles.selectList } }}
                                >
                                    {tasksPay && tasksPay.map((obj, index) =>
                                        <MenuItem key={index} className={styles.selectItem} value={obj.taskCode}>{`${obj.taskCode} - ${IsEnglish() ? obj.taskEn : obj.taskFr}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        )
                    }

                    <FormControl fullWidth className="formDivButtons">
                        <Button
                            loading={!isPostCompleted}
                            className="saveButton"
                            onClick={handleSaveButtonClick}
                            variant="success"
                        >
                            {i18next.t('buttons:save')}
                        </Button>
                    </FormControl>
                </div>
            </div>
            <AlertAlgo ref={alertRef} />
        </LoadingLayer>
    )
}

export default withNamespaces(['materialResource', 'error', 'buttons'], { wait: true })(MaterialResourceForm); 